import classnames from 'classnames';
import {IconBase} from 'components/icons/_iconBase';
import {IconProps} from 'components/icons/types';
import * as React from 'react';
import {ResidenceType, StageStatus} from 'features/search/filters/enums';

import 'components/icons/GoogleMapPin/style.scss';
import {getCurrentSite} from 'features/services/utils/env-helper';
import {SITE} from 'features/ui/enums';

interface Props extends IconProps {
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
    stageStatus?: StageStatus;
    residenceType?: ResidenceType;
    active?: boolean;
    isCluster?: boolean;

    text?: string;

}

export const GoogleMapPin: React.FunctionComponent<Props> = ({ width, height, stageStatus, onClick , residenceType, active, isCluster, text}) => {
    /*
    let classes = classnames('marker', {
        'marker--apartment': residenceType === ResidenceType.APARTMENT,
        'marker--house': residenceType === ResidenceType.HOUSE || residenceType === ResidenceType.DETACHED_HOUSE,
        'marker--plot': residenceType === ResidenceType.PLOT,
        'marker--terraced': residenceType === ResidenceType.TOWN_HOUSE || residenceType === ResidenceType.SEMI_DETACHED_HOUSE,
    });
    */

    const currentSite = getCurrentSite();

    const getIconColor = () => {
        if(isCluster && currentSite === SITE.SENIORGARDEN) return '#546C5A';
        if(isCluster) return '#5c6a4a';//'#B85105';
        if(active) return '#3f3f3f';

        switch (stageStatus) {
            case StageStatus.SUCCESSION:
                return '#d3e3db';
            case StageStatus.FORSALE:
                return '#497f71';
            case StageStatus.PLANNED:
                return '#f6f6f4';
            case StageStatus.VIP:
                return '#F2B843';
            case StageStatus.PRESELLING:
                return '#F2B843';
            case StageStatus.SOLD_OUT:
                return '#c64625';
            case StageStatus.MOVE_IN_READY:
                return '#FFD275';
            default:
                return '#6baa99';
        }
    };

    const getIconStroke = () => {
        //if(stageStatus && stageStatus === StageStatus.PLANNED && !active) return '#222220';
        if(stageStatus 
            && (stageStatus === StageStatus.SUCCESSION 
                || stageStatus === StageStatus.PLANNED 
                || stageStatus === StageStatus.PRESELLING 
                || stageStatus === StageStatus.MOVE_IN_READY 
                || stageStatus === StageStatus.VIP) && !active
            ) return '#3f3f3c';

        return '#fff';
    };

    const getIconBorder = () => {
        //if(stageStatus && stageStatus === StageStatus.PLANNED && !active) return 'rgb(134 134 134)';
        if(stageStatus 
            && (stageStatus === StageStatus.SUCCESSION 
                || stageStatus === StageStatus.PLANNED 
                || stageStatus === StageStatus.PRESELLING 
                || stageStatus === StageStatus.MOVE_IN_READY 
                || stageStatus === StageStatus.VIP) && !active) return '#3f3f3c';

        return '#fff';
    };

    const internalOnClick = (e) => {
        e.stopPropagation();
        if (onClick) onClick(e);
    };

    const classes = classnames('icon--google-maps-pin', {
        'icon--google-maps-pin--active': active,
    });

    return (
        <div className={classes} onClick={internalOnClick}>

            {text && <span className="cluster-text">{text}</span>}

            <IconBase viewPortWidth={49.4} viewPortHeight={47} height={height} width={width}>

                <g>
                    <filter filterUnits="objectBoundingBox" height="131.1%" id="a" width="142%" x="-21%">
                        <feMorphology in="SourceAlpha" operator="dilate" radius=".5"
                                      result="shadowSpreadOuter1"></feMorphology>
                        <feOffset dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
                        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1"
                                        stdDeviation="1.5"></feGaussianBlur>
                        <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out"
                                     result="shadowBlurOuter1"></feComposite>
                        <feColorMatrix in="shadowBlurOuter1"
                                       values="0 0 0 0 0.247058824 0 0 0 0 0.247058824 0 0 0 0 0.235294118 0 0 0 0.2 0">
                        </feColorMatrix>
                    </filter>
                    <g>
                        <g transform="translate(4 2)">
                            <g>
                                <g transform="translate(4 2)">
                                    <g>
                                        <path
                                            id="b_00000041270208862419857370000004356214014539124661_"
                                            className="shadow"
                                            style={{fill:'#6F7173', stroke: 'none', opacity: '0.7'}}
                                            d="M10.1,39.5L10,37.8L8.9,16.3
								c-0.1-2.4,0.5-4.8,1.7-6.9c3.7-6.5,12.2-8.7,19.1-4.8c6.9,3.9,9.5,12.3,5.8,18.9c-1.2,2.1-2.9,3.8-5,5c0,0-0.3,0.2-18.8,10.3
								L10.1,39.5z"/>
                                    </g>
                                </g>
                            </g>
                            <g className="st1" filter="url(#a)" style={{display:'none'}}>
                                <path
                                    id="b_00000159457153079063151920000012197003366849289369_"
                                    style={{display: 'inline'}}
                                    className="st2" d="M14,40.1l-0.9-1.5L1.6,20.5
						c-1.3-2.1-1.9-4.4-1.9-6.8C-0.4,6.2,6,0.1,13.9,0.1c7.9,0,14.3,6.1,14.3,13.6c0,2.4-0.7,4.7-1.9,6.8c0,0-0.2,0.3-11.4,18.2
						L14,40.1z"/>
                            </g>
                            <g>
                                <path
                                    id="b_00000172425495316631197140000001223458883506054838_"
                                    style={{fill:getIconColor(), stroke: getIconBorder(), strokeWidth:1.5}}  className="st3" d="M14,40.1l-0.9-1.5L1.6,20.5
						c-1.3-2.1-1.9-4.4-1.9-6.8C-0.4,6.2,6,0.1,13.9,0.1c7.9,0,14.3,6.1,14.3,13.6c0,2.4-0.7,4.7-1.9,6.8c0,0-0.2,0.3-11.4,18.2
						L14,40.1z"/>
                            </g>
                        </g>
                        {residenceType === ResidenceType.APARTMENT &&
                            <g fill={getIconStroke()} stroke="none">
                                <path d="M16.413 9v3.26h-4.348V24H25.11V9h-8.696zm.87 14.565h-1.74v-2.774h1.74v2.774zm3.478-2.776h.87v2.776h-.87V20.79zm3.913 2.776h-2.609v-3.208h-1.304V12.26h-3.913V9.435h7.826v14.13z"/>
                            </g>
                        }

                        {(residenceType === ResidenceType.HOUSE) &&
                            <g fill={getIconStroke()} stroke="none">
                                <path d="M25.68 14.674l-3.002-3.196V8.087h-1.63v1.652L18.602 7.13l-7.07 7.544.29.309.672-.718v7.722h12.222v-7.73l.68.726.284-.31zm-5.651 6.878h-2.854v-5.18h2.854v5.18z"/>
                            </g>
                        }

                        {((currentSite !== SITE.NO && residenceType === ResidenceType.SEMI_DETACHED_HOUSE) || residenceType === ResidenceType.TOWN_HOUSE || residenceType === ResidenceType.DETACHED_HOUSE) &&
                            <path fill={getIconStroke()} stroke="none" d="M25.57 12.994L21.576 9l-3.291 3.289L14.996 9 11 12.994l.281.282.228-.232v9.515h13.548v-9.515l.233.236.28-.286zm-9.874 9.169h-1.41v-2.53h1.41v2.53zm6.58 0h-1.41v-2.53h1.413l-.004 2.53z"/>
                        }

                        {(currentSite === SITE.NO && residenceType === ResidenceType.SEMI_DETACHED_HOUSE) &&
                            <path fill={getIconStroke()} stroke="none" d="M 25.6581 15.2668 l -4.1239 -3.4405 L 18.186 9.2748 l -3.3617 2.6005 L 10.8224 15.0349 l 0.1951 0.3049 l 0.6589 -0.5368 v 7.5031 h 12.9994 V 14.9373 l 0.7179 0.6466 Z M 15.7019 21.9054 h -1.3528 v -3.1395 h 1.3528 s 0 3.1395 0 3.1395 Z Z M 22.015 21.9054 h -1.3523 v -3.1395 h 1.3562 s -0.0039 3.1395 -0.0039 3.1395 Z"/>
                        }
                    </g>
                </g>

                {/*
                <>
                    <defs>
                        <path id="b" d="M14.368 40l-.926-1.464L1.934 20.415A13.012 13.012 0 0 1 0 13.567C0 6.124 6.4 0 14.247 0c7.919 0 14.324 6.085 14.324 13.567a12.81 12.81 0 0 1-1.912 6.764s-.17.279-11.37 18.2L14.368 40z"/>
                        <filter id="a" width="142%" height="131.1%" x="-21%" filterUnits="objectBoundingBox">
                            <feMorphology in="SourceAlpha" operator="dilate" radius=".5" result="shadowSpreadOuter1"/>
                            <feOffset dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
                            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5"/>
                            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
                            <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0.247058824 0 0 0 0 0.247058824 0 0 0 0 0.235294118 0 0 0 0.2 0"/>
                        </filter>
                    </defs>
                    <g fill="none" fillRule="evenodd">
                        <g fillRule="nonzero" transform="translate(4 2)">
                            <use fill="#fff" filter="url(#a)" xlinkHref="#b"/>
                            <use fill={getIconColor()} stroke="#FFF" xlinkHref="#b"/>
                        </g>
                        {residenceType === ResidenceType.APARTMENT &&
                            <g fill={getIconStroke()} stroke="none">
                                <path d="M16.413 9v3.26h-4.348V24H25.11V9h-8.696zm.87 14.565h-1.74v-2.774h1.74v2.774zm3.478-2.776h.87v2.776h-.87V20.79zm3.913 2.776h-2.609v-3.208h-1.304V12.26h-3.913V9.435h7.826v14.13z"/>
                            </g>
                        }

                        {(residenceType === ResidenceType.HOUSE || residenceType === ResidenceType.DETACHED_HOUSE) &&
                            <g fill={getIconStroke()} stroke="none">
                                <path d="M25.68 14.674l-3.002-3.196V8.087h-1.63v1.652L18.602 7.13l-7.07 7.544.29.309.672-.718v7.722h12.222v-7.73l.68.726.284-.31zm-5.651 6.878h-2.854v-5.18h2.854v5.18z"/>
                            </g>
                        }

                        {(residenceType === ResidenceType.TOWN_HOUSE || residenceType === ResidenceType.SEMI_DETACHED_HOUSE) &&
                            <path fill={getIconStroke()} stroke="none" d="M25.57 12.994L21.576 9l-3.291 3.289L14.996 9 11 12.994l.281.282.228-.232v9.515h13.548v-9.515l.233.236.28-.286zm-9.874 9.169h-1.41v-2.53h1.41v2.53zm6.58 0h-1.41v-2.53h1.413l-.004 2.53z"/>
                        }
                    </g>
                </>
                */}
            </IconBase>
        </div>
    );
};
